import React, { useState } from "react";
import { OPTIONS_DATA_MAPPER, usCurrency, clearFieldValues } from "../../utils";
import AddToolTip from "../AddToolTip";
import { get, isNull } from "lodash";
import { onProfileNameChange } from "../../services";
import { Link } from "react-router-dom";
import { calculateTotalVestedBalanceFromSourceBalance } from "../../containers/Distribution/WithdrawalRequestContainer/DistributionConstantsAndFunctions";

const PlanCards = (props) => {
  const {
    plans,
    checked,
    fields,
    setFieldValue,
    handleChange,
    values,
    selectedPlan,
    setSelectedPlan,
    disable = false,
    isTransfer = false,
    isViewOnly = false,
    empPlans,
    module = null,
    setValues,
  } = props;

  const onPlanChange = (ind, data) => {
    let updatedValues;
    updatedValues = clearFieldValues({
      values,
      fieldsToClear: [
        fields.withdrawalType,
        fields.withdrawalName,
        fields.modeOfPayment,
        fields.withdrawEntireAmount,
        fields.netAmountRequested,
        fields.withdrawalFee,
        fields.periodicPaymentType,
        fields.checkFee,
        fields.earlyWithdrawalPenalty,
        fields.eftFee,
        fields.feesPaymentMethodsApplicable,
        fields.rollOverFee,
        fields.withdrawalFee,
      ],
    });
    setValues({
      ...values,
      ...updatedValues,
      [fields.planName]: data.planName,
    });
    setSelectedPlan(ind);
  };

  return (
    <div>
      {plans &&
        plans.map((data, index) => {
          let vestedBalance = 0;
          if (!isTransfer)
            vestedBalance = calculateTotalVestedBalanceFromSourceBalance(
              data?.sourceBalances
            );
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
                // height: "5%",
                padding: "12px",
                border:
                  index == selectedPlan || plans.length == 1
                    ? "1px solid #307BF6"
                    : "1px solid #BDBDBD",
                backgroundColor:
                  index == selectedPlan || plans.length == 1
                    ? "rgba(48, 123, 246, 0.1)"
                    : "white",
                borderRadius: "5px",
                marginBottom: "15px",
                cursor: "pointer",
              }}
              onClick={() => {
                if (!disable) {
                  setSelectedPlan(index);
                  onPlanChange(index, data);
                  setFieldValue(fields.planId, data.id);
                }
              }}
            >
              {!isViewOnly && (
                <input
                  style={{ margin: "0px 33px 0px 18px" }}
                  checked={index == selectedPlan || plans.length == 1}
                  type="radio"
                  value={values[fields.planId]}
                  onChange={() => {
                    //setFieldValue(fields.planId, index + 1);
                  }}
                  name="plan"
                  // onClick={() => setSelectedPlan(index)}
                />
              )}
              <p
                className={isViewOnly ? "ml-5" : ""}
                style={{
                  fontWeight: "500",
                  fontSize: "14px",
                  color: "#3B3B3B",
                  width: "45%",
                  marginTop: "15px",
                  paddingRight: "23px",
                }}
              >
                {data?.planName}
              </p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  borderRight: " 0.5px solid #BDBDBD",
                  borderLeft: " 0.5px solid #BDBDBD",
                  paddingLeft: isTransfer ? "50px" : "25px",
                  paddingRight: isTransfer ? "50px" : "25px",
                }}
              >
                <p
                  style={{
                    fontWeight: "400",
                    fontSize: "14px",
                    color: "#777777",
                    padding: "0px",
                    margin: "0px",
                  }}
                >
                  Available Balance
                  {/* {module == "Loans" ? "Account Balance" : "Available Balance"} */}
                </p>
                <p
                  style={{
                    fontWeight: "500",
                    fontSize: "14px",
                    color: "#000000",
                    padding: "0px",
                    margin: "0px",
                  }}
                >
                  {usCurrency(data?.accountBalance ? data?.accountBalance : 0)}
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  paddingLeft: isTransfer ? "50px" : "35px",
                  alignItems: "flex-end",
                }}
              >
                <p
                  style={{
                    fontWeight: "400",
                    fontSize: "14px",
                    color: "#777777",
                    padding: "0px",
                    margin: "0px",
                  }}
                >
                  Vested Balance
                </p>
                <p
                  style={{
                    fontWeight: "500",
                    fontSize: "14px",
                    color: "#000000",
                    padding: "0px",
                    margin: "0px",
                  }}
                >
                  {usCurrency(isTransfer ? data.vestedBalance : vestedBalance)}
                </p>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default PlanCards;
